import wavemill_trials1 from '../../assets/wavemill_trials1.jpg'
import wavemill_trials2 from '../../assets/wavemill_trials2.jpg'
import wavemill3 from '../../assets/wavemill3.jpg';  

export default function TabTrials() {

    const myheader1 = {
      textAlign: 'center',
      // fontFamily: 'Calibri',
   
       
    };

  return (
 <div>
    <section className="align_left">  
    <h3 style={myheader1}>
    Period: July – August 2009. Location: Moreton Bay, Brisbane, Queensland, Australia
    </h3>

    <img src={wavemill_trials1} style={{marginLeft:"1rem", objectFit: 'fill', width: '650px'}} alt='' />	
 
    <p className="align_left">
      <b>The Wave Mill dimensions:</b><br />
      Length: 30 m;<br />
      Width: 1.5 m;<br />
    </p>        
                  
    <br />
   
    <p className="align_left">
      <b>Turbine configuration</b> <br />     
      Platform has two air-ducts and two 600W generators                 
    </p>
       
    <img src={wavemill3} style={{marginLeft:"1rem", objectFit: 'fill' }} alt='' />	         
    
    <p className="align_left">
      <b>Wave conditions</b><br />
      Wave period (T): min 2 seconds; max 3 seconds;<br />
      Wave height (H): min 0.4 meter; max 0.6 meter;<br />
      <br />
      <b>Wave input</b><br />
      Wave Power(Wp) = 0.5 * H² * T (kW)<br />
      Min: 0.14 kW/m; Max: .81kW/m;<br />
    </p>        
     
    <img src={wavemill_trials2} style={{marginLeft:"1rem", objectFit: 'fill', width: '650px' }} alt='' />	         
    
    </section>
    <section className="align_left">    
    <br />
    <b>Performance</b><br />
    Pneumatics, air flow, air velocity<br />
    <br />
    Fan diameter (D): 0.5 m<br />
    Air velocity (m/s) (V): min 8 m/s; max 15m/s;<br />
    Air density (AD) = 1.22<br />
    Power (W) = 0.5 * AD * (D² * 0.7854) * V³<br />
    Power: min 50 W; max 330W;<br />
    Unit has two air-ducts (inlet and outlet) and two air-turbines:<br />
    Total measured pneumatic power: min 100W; max 660W;<br />
    Pneumatic efficiency: min 41%; max 81%;<br />

    <br />
    <b>Output</b><br />
    Generator:<br />
    Rated power: 600W;<br />
    <br />
    Measured output: min 15 W; max 145W;<br />
    <br />
    Platform has two ducts and two generators:<br />
    <br />
    Total measured power output: min 30W; max 290W;<br />
    Recorded efficiency "from wave to wire": min 22%; max 36%;<br />
    </section>
     </div>

  )
}
